import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

export const saleRemindersApi = {
  list: (params = {}) => axiosInstance.get(API_ENDPOINTS.SALE_REMINDERS.LIST, { params }),
  update: (id, data) => axiosInstance.patch(API_ENDPOINTS.SALE_REMINDERS.DETAIL(id), data),
  remove: (id) => axiosInstance.delete(API_ENDPOINTS.SALE_REMINDERS.DETAIL(id)),
};
